import React from "react";
import styles from "./ProjectList.module.scss";
import ProjectListItem from "./ProjectListItem";
import projects from "../../data/_data.json";

const ProjectList = () => {
  return (
    <section className={styles.container}>
      <h1>My recent work</h1>

      <ul>
        {!!projects &&
          projects.map((project) => {
            return <ProjectListItem key={project.id} {...project} />;
          })}
      </ul>
    </section>
  );
};

export default ProjectList;
